// import external dependencies
import 'jquery';

// Import Bootstrap
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/collapse';

// import local dependencies
import $log from './util/logger'; // eslint-disable-line no-unused-vars
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import templateAbout from './routes/about';

$log.debugEnabled(true);

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  templateAbout,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
